export const APP_NAME = 'Grid Calculator';

export const ROOT_ELEMENT_ID = '⚛️';
